const POST_HEADER = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
}

export {
    POST_HEADER
}